
import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { approveCustomerCICReportingApi, createCustomerCICReportingApi, deleteCustomerCICReportingApi, fetchCustomerCICReportingApi, fetchCustomerCICReportingLatestVersionApi, fetchCustomerCICReportingsApi, fetchCustomerCICReportingVersionApi, fetchCustomerCICReportingVersionDetailsApi, rejectCustomerCICReportingApi, updateCustomerCICReportingApi } from "./api";
import { CreateCustomerCICReportingSaga, CustomerCICReportingFetchSaga, CustomerCICReportingReduxTypes, ApproveRejectCustomerCICReportingSaga, UpdateCustomerCICReportingSaga, DeleteCustomerCICReportingSaga, CustomerCICReportingVersionsSaga, CustomerCICReportingLatestVersionSaga, CustomerCICReportingDetailsSaga } from "./types";

function* fetchCustomerCICReportingsIds({ payload }: CustomerCICReportingFetchSaga): SagaIterator {
    try {
        const response = yield call(fetchCustomerCICReportingsApi, payload);

        yield put({
            type: CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTINGS_IDS_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTINGS_IDS_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchCustomerCICReportings({ payload }: CustomerCICReportingFetchSaga): SagaIterator {
    try {
        const response = yield call(fetchCustomerCICReportingsApi, payload);

        yield put({
            type: CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTINGS_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTINGS_ERROR,
            payload: { error: error }
        });
    }
}
function* fetchCustomerCICReporting({ payload }: CustomerCICReportingFetchSaga): SagaIterator {
    try {
        const response = yield call(fetchCustomerCICReportingApi, payload);

        yield put({
            type: CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_ERROR,
            payload: { error: error }
        });
    }
}
function* fetchCustomerCICReportingVersions({ payload }: CustomerCICReportingVersionsSaga): SagaIterator {
    try {
        const response = yield call(fetchCustomerCICReportingVersionApi, payload);

        yield put({
            type: CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION_ERROR,
            payload: { error: error }
        });
    }
}
function* fetchCustomerCICReportingLatestVersions({ payload }: CustomerCICReportingLatestVersionSaga): SagaIterator {
    try {
        const response = yield call(fetchCustomerCICReportingLatestVersionApi, payload);

        yield put({
            type: CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_LATEST_VERSION_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_LATEST_VERSION_ERROR,
            payload: { error: error }
        });
    }
}
function* fetchCustomerCICReportingVersionsDetail({ payload }: CustomerCICReportingDetailsSaga): SagaIterator {
    try {
        const response = yield call(fetchCustomerCICReportingVersionDetailsApi, payload);

        yield put({
            type: CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION_DETAILS_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION_DETAILS_ERROR,
            payload: { error: error }
        });
    }
}
function* createCustomerCICReporting({ payload }: CreateCustomerCICReportingSaga): SagaIterator {
    try {
        const response = yield call(createCustomerCICReportingApi, payload);

        yield put({
            type: CustomerCICReportingReduxTypes.CREATE_CUSTOMER_CIC_REPORTING_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CustomerCICReportingReduxTypes.CREATE_CUSTOMER_CIC_REPORTING_ERROR,
            payload: { error: error }
        });
    }
}
function* updateCustomerCICReporting({ payload }: UpdateCustomerCICReportingSaga): SagaIterator {
    try {
        const response = yield call(updateCustomerCICReportingApi, payload);

        yield put({
            type: CustomerCICReportingReduxTypes.UPDATE_CUSTOMER_CIC_REPORTING_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CustomerCICReportingReduxTypes.UPDATE_CUSTOMER_CIC_REPORTING_ERROR,
            payload: { error: error }
        });
    }
}
function* deleteCustomerCICReporting({ payload }: DeleteCustomerCICReportingSaga): SagaIterator {
    try {
        const response = yield call(deleteCustomerCICReportingApi, payload);

        yield put({
            type: CustomerCICReportingReduxTypes.DELETE_CUSTOMER_CIC_REPORTING_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CustomerCICReportingReduxTypes.DELETE_CUSTOMER_CIC_REPORTING_ERROR,
            payload: { error: error }
        });
    }
}
function* approveCustomerCICReporting({ payload }: ApproveRejectCustomerCICReportingSaga): SagaIterator {
    try {
        const response = yield call(approveCustomerCICReportingApi, payload);

        yield put({
            type: CustomerCICReportingReduxTypes.APPROVE_CUSTOMER_CIC_REPORTING_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CustomerCICReportingReduxTypes.APPROVE_CUSTOMER_CIC_REPORTING_ERROR,
            payload: { error: error }
        });
    }
}
function* rejectCustomerCICReporting({ payload }: ApproveRejectCustomerCICReportingSaga): SagaIterator {
    try {
        const response = yield call(rejectCustomerCICReportingApi, payload);

        yield put({
            type: CustomerCICReportingReduxTypes.REJECT_CUSTOMER_CIC_REPORTING_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CustomerCICReportingReduxTypes.REJECT_CUSTOMER_CIC_REPORTING_ERROR,
            payload: { error: error }
        });
    }
}

export function* watchfetchCustomerCICReportingsIds() {
    yield takeEvery(CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTINGS_IDS, fetchCustomerCICReportingsIds);
}

export function* watchfetchCustomerCICReportings() {
    yield takeEvery(CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTINGS, fetchCustomerCICReportings);
}
export function* watchfetchCustomerCICReporting() {
    yield takeEvery(CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING, fetchCustomerCICReporting);
}
export function* watchfetchCustomerCICReportingVersions() {
    yield takeEvery(CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION, fetchCustomerCICReportingVersions);
}
export function* watchfetchCustomerCICReportingLatestVersions() {
    yield takeEvery(CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_LATEST_VERSION, fetchCustomerCICReportingLatestVersions);
}
export function* watchfetchCustomerCICReportingVersionsDetail() {
    yield takeEvery(CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION_DETAILS, fetchCustomerCICReportingVersionsDetail);
}
export function* watchcreateCustomerCICReporting() {
    yield takeEvery(CustomerCICReportingReduxTypes.CREATE_CUSTOMER_CIC_REPORTING, createCustomerCICReporting);
}
export function* watchupdateCustomerCICReporting() {
    yield takeEvery(CustomerCICReportingReduxTypes.UPDATE_CUSTOMER_CIC_REPORTING, updateCustomerCICReporting);
}
export function* watchdeleteCustomerCICReporting() {
    yield takeEvery(CustomerCICReportingReduxTypes.DELETE_CUSTOMER_CIC_REPORTING, deleteCustomerCICReporting);
}
export function* watchapproveCustomerCICReporting() {
    yield takeEvery(CustomerCICReportingReduxTypes.APPROVE_CUSTOMER_CIC_REPORTING, approveCustomerCICReporting);
}
export function* watchrejectCustomerCICReporting() {
    yield takeEvery(CustomerCICReportingReduxTypes.REJECT_CUSTOMER_CIC_REPORTING, rejectCustomerCICReporting);
}

function* customerCICReportingSaga() {
    yield all([
        fork(watchfetchCustomerCICReportingsIds),
        fork(watchfetchCustomerCICReportings),
        fork(watchfetchCustomerCICReporting),
        fork(watchfetchCustomerCICReportingVersions),
        fork(watchfetchCustomerCICReportingLatestVersions),
        fork(watchfetchCustomerCICReportingVersionsDetail),
        fork(watchcreateCustomerCICReporting),
        fork(watchupdateCustomerCICReporting),
        fork(watchdeleteCustomerCICReporting),
        fork(watchapproveCustomerCICReporting),
        fork(watchrejectCustomerCICReporting)
    ])
}

export default customerCICReportingSaga;
